<template>
  <div>
    <div class="d-flex" id="wrapper">
      <SideBar />
      <div id="page-content-wrapper">
        <nav
          style="justify-content: flex-start"
          class="navbar navbar-expand-lg navbar-light bg-light border-bottom floating"
        >
          <div>
            <button class="btn btn-outline" id="menu-toggle" @click="sidebar">
              <span class="navbar-toggler-icon"></span>
            </button>

            <button
              style="
                color: rgba(0, 0, 0, 0.5);
                border-color: rgba(0, 0, 0, 0.1);
              "
              class="btn btn-outline navbar-toggler"
              type="button"
              data-toggle="collapse"
              data-target="#navbarSupportedContent"
              aria-controls="navbarSupportedContent"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span style="padding-top: 0.5em"
                ><i class="fas fa-user-alt"></i><span class="account-div"></span
                ><i class="fas fa-angle-down"></i
              ></span>
            </button>
          </div>
          <div class="d-flex">
            <!-- <i class="fas fa-home text-muted hover-cursor" @click="toPage('/dashboard')"></i> -->
            <p class="text-primary mb-0 hover-cursor">&nbsp; Assembly</p>
          </div>
          <div class="collapse navbar-collapse" id="navbarSupportedContent">
            <ul class="navbar-nav ml-auto mt-2 mt-lg-0">
              <li class="nav-item dropdown">
                <a
                  class="nav-link dropdown-toggle"
                  href="#"
                  id="navbarDropdown"
                  role="button"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  {{ admin }}
                </a>
                <div
                  class="dropdown-menu dropdown-menu-right"
                  aria-labelledby="navbarDropdown"
                >
                  <a class="dropdown-item link" @click="toPage('/password')">
                    <i class="fas fa-cog"></i
                    ><span class="right-dropdown">Change Password</span></a
                  >
                  <a class="dropdown-item link" @click="handleLogout"
                    ><i class="fas fa-sign-out-alt"></i
                    ><span class="right-dropdown">Logout</span></a
                  >
                </div>
              </li>
            </ul>
          </div>
        </nav>
        <div class="container-fluid">
          <div class="row">
            <div class="col-md-12 grid-margin stretch-card card-div">
              <div class="container">
                <h5 class="card-title mt-3 mb-5">Ubah Spesifikasi</h5>
              </div>
              <div class="container">
                <div class="row mx-0 align-items-center">
                  <div class="col-lg-2">Perakitan</div>
                  <div class="col-lg-10 pl-0">
                    <multiselect
                      v-model="perakitan"
                      :options="perakitanOptions"
                      :allow-empty="false"
                      :select-label="''"
                      :deselect-label="''"
                      placeholder="Pilih Perakitan"
                    ></multiselect>
                  </div>
                </div>
                <div
                  class="row mx-0 align-items-center my-2"
                  v-if="
                    perakitan == 'Upgrade / Downgrade (Full Part)' &&
                    allowSetWrong
                  "
                >
                  <div class="col-lg-2">Kasus</div>
                  <div class="col-lg-10 pl-0">
                    <multiselect
                      v-model="selectedCase"
                      :options="caseOptions"
                      label="caseDescription"
                      :allow-empty="false"
                      :select-label="''"
                      :deselect-label="''"
                      placeholder="Pilih Kasus"
                    ></multiselect>
                  </div>
                </div>
                <div
                  class="row mx-0 align-items-center my-2"
                  v-if="perakitan == 'Upgrade / Downgrade (Full Part)'"
                >
                  <div class="col-lg-2">Gudang</div>
                  <div class="col-lg-10 pl-0" v-if="enableSNWrongAllWarehouse">
                    <multiselect
                      v-model="warehouse"
                      :options="selectWarehouse"
                      :allow-empty="false"
                      :select-label="''"
                      :deselect-label="''"
                      placeholder="Pilih Warehouse"
                    ></multiselect>
                  </div>
                  <div class="col-lg-10 pl-0" v-else>
                    <multiselect
                      v-model="warehouse"
                      :options="selectWarehouse"
                      :allow-empty="false"
                      :select-label="''"
                      :deselect-label="''"
                      placeholder="Pilih Warehouse"
                      disabled
                    ></multiselect>
                  </div>
                </div>
                <div
                  class="row mx-0 align-items-start my-2"
                  v-if="perakitan == 'Upgrade / Downgrade (Full Part)'"
                >
                  <div class="col-lg-2">Spesifikasi diinginkan</div>
                  <div class="col-lg-10 pl-0">
                    <multiselect
                      v-model="type"
                      :options="selectType"
                      :allow-empty="false"
                      :select-label="''"
                      :deselect-label="''"
                      placeholder="Pilih Type"
                    ></multiselect>
                    <multiselect
                      class="my-2"
                      v-model="itemChoose"
                      :options="selectItem"
                      :allow-empty="false"
                      track-by="itemName"
                      label="itemName"
                      select-labe="itemName"
                      :deselect-label="''"
                      placeholder="Pilih Unit"
                      :disabled="type == ''"
                    ></multiselect>
                    <button
                      class="btn btn-primary w-100 my-2"
                      @click="openModalBom"
                      :disabled="itemChoose == ''"
                    >
                      Pilih BOM
                    </button>
                    <div
                      class="w-100 p-2 component-border rounded mb-2"
                      v-if="bom"
                    >
                      <div
                        v-for="(item, i) in bom.itemBom"
                        :key="`itemType-${i}`"
                      >
                        <div
                          v-for="(it, index) in item.itemQty"
                          :key="`${item.itemName}-${index}`"
                        >
                          {{ item.itemName }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class="row mx-0 align-items-start my-2"
                  v-if="perakitan == 'Upgrade / Downgrade (Full Part)'"
                >
                  <div class="col-lg-2 mt-2">SC/SN</div>
                  <div class="col-lg-10 pl-0">
                    <input
                      :disabled="!bom.itemBom"
                      type="text"
                      v-model="snsc"
                      class="form-control"
                      v-on:keyup.enter="doSearchSn"
                    />
                    <div class="container my-2" v-if="snSelected.length > 0">
                      <div
                        class="row align-items-center justify-content-between"
                        v-for="(item, i) in snSelected"
                        :key="`selectedSn-${i}`"
                      >
                        <div
                          class="col-lg-11 py-2 mt-1 component-border rounded"
                        >
                          <div>{{ item.itemGroup }} - {{ item.itemName }}</div>
                          <div>
                            {{ item.serialNumber }}/{{ item.stockCode }}
                          </div>
                        </div>
                        <button
                          class="btn btn-danger py-1 px-3 mr-3 font-weight-bold"
                          @click="deleteSelectedSn(item)"
                        >
                          -
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class="row mx-0 align-items-start my-2"
                  v-if="perakitan == 'Lepas Part'"
                >
                  <div class="col-lg-2 mt-2">SC/SN</div>
                  <div class="col-lg-10 pl-0">
                    <input
                      type="text"
                      v-model="snsc"
                      class="form-control"
                      v-on:keyup.enter="doSearchSnRemove"
                    />
                    <div
                      class="col-lg-12 my-2 py-2 component-border rounded"
                      v-if="snLepas.itemGroup"
                    >
                      <div>
                        {{ snLepas.itemGroup }} - {{ snLepas.itemName }}
                      </div>
                      <div>
                        {{ snLepas.stockCode }}/{{ snLepas.serialNumber }} ({{
                          snLepas.status
                        }})
                      </div>
                    </div>
                    <div
                      class="col-lg-12 mt-4 px-0"
                      v-if="selectLepasPart.length > 0"
                    >
                      <div>Pilih part yang dilepas dari unit</div>
                      <div class="col-lg-12 my-2 py-3 border rounded">
                        <div
                          v-for="(item, i) in selectLepasPart"
                          :key="`selectLepasPart-${i}`"
                        >
                          <div v-for="j in item.itemQty" :key="j">
                            <input
                              v-model="removeSelected"
                              :id="item.itemName"
                              :value="`${item.itemCode}-${j}`"
                              type="checkbox"
                              :disabled="
                                item.itemName.toLowerCase().includes('body') ||
                                item.itemName
                                  .toLowerCase()
                                  .includes('motherboard')
                              "
                            />
                            <label for="comp1" class="mb-0">{{
                              item.itemName
                            }}</label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-if="perakitan == 'Update Info BOM'">
                  <div class="row align-items-center my-2 mx-0">
                    <div class="col-lg-2">Tipe Unit</div>
                    <div class="col-lg-10 pl-0">
                      <multiselect
                        v-model="type"
                        :options="selectType"
                        :allow-empty="false"
                        :select-label="''"
                        :deselect-label="''"
                        placeholder="Pilih Type"
                      ></multiselect>
                    </div>
                  </div>
                  <div class="row mx-0 align-items-center my-2">
                    <div class="col-lg-2">Unit</div>
                    <div class="col-lg-10 pl-0">
                      <multiselect
                        class="my-1"
                        v-model="itemChoose"
                        :options="selectItem"
                        :allow-empty="false"
                        track-by="itemName"
                        label="itemName"
                        :deselect-label="''"
                        placeholder="Pilih Unit"
                        :disabled="type == ''"
                      ></multiselect>
                    </div>
                  </div>
                  <div class="form-group row mx-0 align-items-center">
                    <label class="col-lg-2 col-form-label">Pilih Metode</label>
                    <div class="col-lg-10 pl-0">
                      <div class="row mx-0">
                        <div class="col-sm-6 px-0 pr-2" v-if="permissionChangeInfoBomByModel">
                          <div
                            class="border rounded p-2"
                            :class="{
                              'border-primary': selectedMethod === 'model',
                            }"
                            style="cursor: pointer"
                            @click="handleClickMethod('model')"
                          >
                            <div class="custom-control custom-radio">
                              <input
                                class="custom-control-input"
                                type="radio"
                                name="updateMethod"
                                id="updateByModel"
                                value="model"
                                v-model="selectedMethod"
                                @input="handleChangeMethod('model')"
                              />
                              <label
                                class="custom-control-label"
                                for="updateByModel"
                              >
                                Update by Unit Model
                              </label>
                            </div>
                          </div>
                        </div>

                        <div class="col-sm-6 px-0" v-if="permissionChangeInfoBomBySn">
                          <div
                            class="border rounded p-2"
                            :class="{
                              'border-primary': selectedMethod === 'serial',
                            }"
                            style="cursor: pointer"
                            @click="handleClickMethod('serial')"
                          >
                            <div class="custom-control custom-radio">
                              <input
                                type="radio"
                                class="custom-control-input"
                                name="updateMethod"
                                id="updateBySN"
                                value="serial"
                                @input="handleChangeMethod('serial')"
                                v-model="selectedMethod"
                              />
                              <label
                                class="custom-control-label"
                                for="updateBySN"
                              >
                                Update by Serial Number (SN)
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div style="border-top: 1px solid #dee2e6"></div>
                  <div
                    v-if="
                      perakitan == 'Update Info BOM' &&
                      selectedMethod == 'serial'
                    "
                  >
                    <div class="mt-4 p-3" style="border-radius: 8px; border: 1px solid #CFD3D9 ">
                      <div
                        class="d-flex justify-content-between align-items-center mb-3"
                      >
                        <div
                          class="d-flex align-items-center"
                          style="gap: 8px; flex: 1"
                        >
                          <img
                            src="~@/assets/icon/letter-red.svg"
                            alt="letter-red"
                          />
                          <p class="font-weight-bold m-0">BOM Lama</p>
                        </div>
                        <button
                          type="button"
                          class="btn btn-sm"
                          @click="addItemSerialNumber()"
                          :disabled="arrItemSN.length == 10"
                          style="
                            border-radius: 8px;
                            border: 1px solid #cfd3d9;
                            font-size: 0.875rem;
                            font-weight: 600;
                            color: #2e3646;
                          "
                        >
                          + Add New Serial Number (SN)
                        </button>
                      </div>
                      <div
                        v-for="(item, index) in arrItemSN"
                        :key="index"
                        class="d-flex mb-2 px-0 align-items-start"
                        style="gap: 12px"
                      >
                        <div class="d-flex pr-0 mt-2" style="gap: 30px">
                          <label
                            class="small m-0"
                            style="font-size: 1rem; flex: 1"
                            >Serial Number {{ index + 1 }}</label
                          >
                          <p class="m-0">:</p>
                        </div>
                        <div style="flex: 1">
                          <div
                            class="d-flex align-items-center"
                            style="gap: 12px"
                          >
                            <div style="flex: 1">
                              <input
                                type="text"
                                :class="['form-control', {'border-danger': item.error}]"
                                placeholder="Masukkan Serial Number"
                                v-model="item.serialNumber"
                                @input="debounceSearch(index)"
                                style="border-radius: 8px"
                              />
                            </div>
                            <div style="flex: 1">
                              <input
                                type="text"
                                :class="['form-control', {'border-danger': item.error}]"
                                placeholder="BOM ID"
                                v-model="item.bomId"
                                style="border-radius: 8px"
                                disabled
                              />
                            </div>
                          </div>
                          <small class="text-danger">
                            {{ item.error }}
                          </small>
                        </div>
                        <div
                          class="d-flex align-items-end"
                          v-if="arrItemSN.length > 1"
                        >
                          <button
                            type="button"
                            class="btn"
                            @click="removeItemSerialNumber(item.id)"
                          >
                            <i
                              class="fa fa-times fa-lg"
                              style="color: #2e3646"
                            ></i>
                          </button>
                        </div>
                      </div>
                    </div>
                    <div :class="['toggle-card mt-4']" v-if="!selectedNewBom">
                      <div>
                        <button
                          @click="openModalOnboardBom('onboard')"
                          class="btn toggle-btn btn-new-bom"
                        >
                          Pilih BOM Baru
                        </button>
                      </div>
                    </div>
                    <div
                      :class="['selected-toggle-card mt-4']"
                      v-else-if="selectedNewBom"
                    >
                      <div>
                        <div
                          class="d-flex align-items-center justify-content-between"
                        >
                          <div
                            class="d-flex align-items-center"
                            style="gap: 8px; flex: 1"
                          >
                            <img
                              src="~@/assets/icon/letter-green.svg"
                              alt="letter-red"
                            />
                            <p class="font-weight-bold m-0">BOM Baru</p>
                          </div>
                          <button
                            class="btn p-0"
                            @click="openModalOnboardBom('onboard')"
                          >
                            <img
                              src="~@/assets/icon/refresh-grey.svg"
                              alt="refresh-grey"
                            />
                          </button>
                        </div>
                        <div>
                          <div class="py-3 px-0">
                            <div
                              class="d-flex justify-content-between align-items-start mb-2"
                            >
                              <h6 class="mb-0 font-weight-bold">
                                {{ selectedNewBom.bomName }}
                              </h6>
                              <!-- <span 
                                      class="badge px-3 py-1"
                                      :class="'badge-' + bom.statusColor"
                                  >
                                      {{ bom.status }}
                                  </span> -->
                            </div>

                            <div
                              v-for="(comp, i) in selectedNewBom.itemBom"
                              :key="`itemBom-${i}`"
                            >
                              <p
                                v-for="(qty, j) in comp.itemQty"
                                :key="`comp${i}-${j}`"
                                class="mb-1 small text-left"
                                style="font-size: 1rem"
                              >
                                {{ comp.itemName }}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="mt-4"
                    v-if="
                      perakitan == 'Update Info BOM' &&
                      selectedMethod == 'model'
                    "
                  >
                    <div class="toggle-container">
                      <div :class="['toggle-card']" v-if="!selectedOldBom">
                        <button
                          @click="openModalOnboardBom('removable')"
                          class="btn toggle-btn btn-old-bom font-weight-bolder"
                        >
                          Pilih BOM Lama
                        </button>
                      </div>
                      <div
                        :class="['selected-toggle-card']"
                        v-else-if="selectedOldBom"
                      >
                        <div>
                          <div
                            class="d-flex align-items-center justify-content-between"
                          >
                            <div
                              class="d-flex align-items-center"
                              style="gap: 8px; flex: 1"
                            >
                              <img
                                src="~@/assets/icon/letter-red.svg"
                                alt="letter-red"
                              />
                              <p class="font-weight-bold m-0">BOM Lama</p>
                            </div>
                            <button
                              class="btn p-0"
                              @click="openModalOnboardBom('removable')"
                            >
                              <img
                                src="~@/assets/icon/refresh-grey.svg"
                                alt="refresh-grey"
                              />
                            </button>
                          </div>
                          <div>
                            <div class="py-3 px-0">
                              <div
                                class="d-flex justify-content-between align-items-start mb-2"
                              >
                                <h6 class="mb-0 font-weight-bold">
                                  {{ selectedOldBom.bomName }}
                                </h6>
                                <!-- <span 
                                      class="badge px-3 py-1"
                                      :class="'badge-' + bom.statusColor"
                                  >
                                      {{ bom.status }}
                                  </span> -->
                              </div>

                              <div
                                v-for="(comp, i) in selectedOldBom.itemBom"
                                :key="`itemBom-${i}`"
                              >
                                <p
                                  v-for="(qty, j) in comp.itemQty"
                                  :key="`comp${i}-${j}`"
                                  class="mb-1 small text-left"
                                  style="font-size: 1rem"
                                >
                                  {{ comp.itemName }}
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div :class="['toggle-card']" v-if="!selectedNewBom">
                        <button
                          @click="openModalOnboardBom('onboard')"
                          class="btn toggle-btn btn-new-bom"
                        >
                          Pilih BOM Baru
                        </button>
                      </div>
                      <div
                        :class="['selected-toggle-card']"
                        v-else-if="selectedNewBom"
                      >
                        <div>
                          <div
                            class="d-flex align-items-center justify-content-between"
                          >
                            <div
                              class="d-flex align-items-center"
                              style="gap: 8px; flex: 1"
                            >
                              <img
                                src="~@/assets/icon/letter-green.svg"
                                alt="letter-red"
                              />
                              <p class="font-weight-bold m-0">BOM Baru</p>
                            </div>
                            <button
                              class="btn p-0"
                              @click="openModalOnboardBom('onboard')"
                            >
                              <img
                                src="~@/assets/icon/refresh-grey.svg"
                                alt="refresh-grey"
                              />
                            </button>
                          </div>
                          <div>
                            <div class="py-3 px-0">
                              <div
                                class="d-flex justify-content-between align-items-start mb-2"
                              >
                                <h6 class="mb-0 font-weight-bold">
                                  {{ selectedNewBom.bomName }}
                                </h6>
                                <!-- <span 
                                      class="badge px-3 py-1"
                                      :class="'badge-' + bom.statusColor"
                                  >
                                      {{ bom.status }}
                                  </span> -->
                              </div>

                              <div
                                v-for="(comp, i) in selectedNewBom.itemBom"
                                :key="`itemBom-${i}`"
                              >
                                <p
                                  v-for="(qty, j) in comp.itemQty"
                                  :key="`comp${i}-${j}`"
                                  class="mb-1 small text-left"
                                  style="font-size: 1rem"
                                >
                                  {{ comp.itemName }}
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- Save Button Area -->
                <div
                  class="text-right my-4"
                  v-if="perakitan == 'Upgrade / Downgrade (Full Part)'"
                >
                  <button
                    class="btn btn-primary py-2 px-3"
                    @click="submitData"
                    :disabled="
                      !this.warehouse ||
                      !this.itemChoose.itemCode ||
                      !this.bom.bomName ||
                      this.bom.itemBom.length == 0 ||
                      this.snSelected.length == 0
                    "
                    v-if="loadingBtnSave == false"
                  >
                    Simpan
                  </button>
                  <button type="button" class="btn btn-primary" disabled v-else>
                    <img src="~@/assets/images/2.gif" style="height: 24px" />
                    Loading
                  </button>
                </div>
                <div class="text-right my-4" v-if="perakitan == 'Lepas Part'">
                  <button class="btn btn-primary py-2 px-3" @click="submitData">
                    Simpan
                  </button>
                </div>
                <div
                  class="text-right my-4"
                  v-if="perakitan == 'Update Info BOM'"
                >
                  <button
                    v-if="!loadingBtnSave"
                    type="button"
                    class="btn btn-primary"
                    @click="updateInfoBom"
                    :disabled="
                      !itemChoose.itemCode ||
                      !selectedOldBom ||
                      !selectedNewBom ||
                      (selectedMethod == 'serial' 
                        && arrItemSN.filter((item) => item.bomId).length < 1)"
                  >
                    Update BOM
                  </button>
                  <button type="button" class="btn btn-primary" disabled v-else>
                    <img src="~@/assets/images/2.gif" style="height: 24px" />
                    Mengirim...
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Modal select bom -->
        <div class="modal fade" id="modalSelectBom" role="dialog">
          <div class="modal-dialog modal-dialog-centered modal-lg">
            <!-- Modal Content -->
            <div class="modal-content">
              <div class="modal-header">
                <div class="change-title">
                  <h4 class="modal-title">Pilih BOM</h4>
                </div>
                <button type="button" class="close" data-dismiss="modal">
                  &times;
                </button>
              </div>
              <div class="modal-body py-3">
                <div
                  class="col-lg-12 component-border bom-selection rounded my-2"
                  v-for="(itemb, index) in selectBom"
                  :key="`selectBom-${index}`"
                  @click="setBom(itemb)"
                >
                  <div>
                    <div>{{ itemb.bomName }}</div>
                    <div
                      v-for="(comp, i) in itemb.itemBom"
                      :key="`itemBom-${i}`"
                    >
                      <div
                        v-for="(qty, j) in comp.itemQty"
                        :key="`comp${i}-${j}`"
                      >
                        {{ comp.itemName }}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-lg-12 py-3"></div>
              </div>
            </div>
          </div>
        </div>
        <!-- Modal Warehouse -->
        <div class="modal fade" id="modalWarehouse" role="dialog">
          <div class="modal-dialog modal-dialog-centered modal-lg">
            <!-- Modal Content -->
            <div class="modal-content">
              <div class="modal-header">
                <div class="change-title">
                  <!-- <h4 class="modal-title">Pilih Warehouse yang dituju untuk sparepart yang dilepas</h4> -->
                </div>
                <button type="button" class="close" data-dismiss="modal">
                  &times;
                </button>
              </div>
              <div class="modal-body py-3">
                <div class="col-lg-12 py-3">
                  <div class="mb-2">
                    Pilih Warehouse yang dituju untuk sparepart yang dilepas
                  </div>
                  <multiselect
                    class="mb-2"
                    v-model="warehouse"
                    :options="selectWarehouse"
                    :allow-empty="false"
                    :select-label="''"
                    :deselect-label="''"
                    placeholder="Pilih Warehouse"
                  ></multiselect>
                </div>
              </div>
              <div class="modal-footer">
                <div class="col-lg-12">
                  <div class="container">
                    <div class="row justify-content-end">
                      <button class="mr-1 btn btn-danger" data-dismiss="modal">
                        Batal
                      </button>
                      <button
                        class="btn btn-primary"
                        @click="confirmRemovePart"
                        :disabled="warehouse == ''"
                        v-if="loadingBtnSave == false"
                      >
                        Simpan
                      </button>
                      <button
                        type="button"
                        class="btn btn-primary"
                        disabled
                        v-else
                      >
                        <img
                          src="~@/assets/images/2.gif"
                          style="height: 24px"
                        />Loading
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <ModalSelectOldNewBom
          :typeBom="openModalSelectBomType"
          @selectedBom="setSelectedOldNewBom"
          :bomData="selectBom"
        />
      </div>
    </div>
  </div>
</template>

<script>
import swal from "sweetalert";
import Multiselect from "vue-multiselect";
import SideBar from "../SideBar.vue";
import ModalSelectOldNewBom from "./CustomComponent/ModalSelectOldNewBom.vue";
import { alert } from "../../utils";
export default {
  name: "ChangeSpecPage",
  components: {
    Multiselect,
    SideBar,
    ModalSelectOldNewBom,
  },
  data() {
    return {
      spaceRegex: /[\u00A0\uFEFF\u202F]/g,
      permission: [],
      admin: "",
      adminId: "",
      warehouse: "Roxy Warehouse - ASN",
      warehouseAwal: "",
      perakitan: "",
      itemChoose: { itemCode: 0, itemName: "Pilih Item" },
      type: "",
      snsc: "",
      bom: "",
      part: "",
      notifTitle: "",
      snItemName: "",
      snSelected: [],
      snLepas: "",
      removeSelected: [],
      selectLepasPart: [],
      selectBom: [],
      selectWarehouse: [],
      selectType: ["Laptop", "CPU"],
      selectItem: [],
      methodOptions: ["Update by Unit Model", "Update by Serial Number (SN)"],
      selectedMethod: "",
      loadingBtnSave: false,
      selectedCase: {
        case: 0,
        caseDescription: "Normal",
      },
      caseOptions: [
        {
          case: 0,
          caseDescription: "Normal",
        },
        { case: 1, caseDescription: "Spesifikasi lama jadi wrong" },
      ],
      getWarehouseStatus: "/Ready Stock & Repair",
      allowSetWrong: false,
      enableSNWrongAllWarehouse: false,

      arrItemSN: [
        {
          id: 0,
          serialNumber: "",
          stockCode:"",
          bomId: "",
          error:"",
        },
      ],
      openModalSelectBomType: "",
      selectedOldBom: null,
      selectedNewBom: null,

      // UPDATE INFO BOM
      onboardItemList: [],
      selectedOnboardItem: null,
      openedBomModal: "",
      debounceSearchTimer: null,
      permissionChangeInfoBomByModel: false,
      permissionChangeInfoBomBySn : false,
    };
  },
  computed: {
    perakitanOptions() {
      const options = ["Upgrade / Downgrade (Full Part)", "Lepas Part"]
      if( this.permissionChangeInfoBomByModel || this.permissionChangeInfoBomBySn ) {
        options.push("Update Info BOM")
      }
      return options;
    },
    onboardItemOptions() {
      return this.onboardItemList.map((item) => {
        return {
          itemCode: item.itemCode,
          itemName: item.itemName,
        };
      });
    },
  },
  methods: {
    debounceSearch(index) {
      clearTimeout(this.debounceSearchTimer);
      this.debounceSearchTimer = setTimeout(() => {
        this.searchBomBySn(index);
      }, 500);
    },
    async searchBomBySn(index) {
      const data = this.arrItemSN[index];

      // Validate if there is already inputted SC or SN
      const listSameSCSNData = this.arrItemSN.filter((item) => item.serialNumber == data.serialNumber || item.stockCode == data.stockCode);
      if(listSameSCSNData.length > 1) {
        this.arrItemSN[index].error = "Serial Number atau Stock Code sudah diinputkan";
        this.$set(this.arrItemSN, index, newData);
        return
      }
      const itemCode = this.itemChoose.itemCode;
      // set reference bom id to match sn input
      const bom = this.arrItemSN.length > 1 && index == 0 ? this.arrItemSN[1].bomId : this.arrItemSN[0].bomId;
      try {
        const response = await this.$http.post(
          process.env.SEARCH_BOM_SCSN,
          {
            scsn: data.serialNumber.replace(this.spaceRegex, " "),
            itemCode: itemCode,
            bom: bom,
          },
          {
            headers: {
              "Asani-Token": localStorage.getItem("jwt"),
            },
          }
        );
        const newData = {
          ...data,
        }
        if(response.data.status == 200){
          newData.bomId = response.data.content.bom;
          newData.stockCode = response.data.content.stockCode;
          newData.serialNumber = response.data.content.serialNumber;
          newData.error = "";
          if(index == 0) {
            this.selectedOldBom = {
              bomName: response.data.content.bom,
              itemBom: response.data.content.bomItem,
            };
          }
        } else {
          newData.error = response.data.message;
          newData.bomId = "";
        }
        this.$set(this.arrItemSN, index, newData);
      } catch (error) {
        swal("Sorry", error.response.data.message, "error", {
          button: "Ok",
        }).then((v) => {
          if (error.response.data.status == 401) {
            this.handleLogout();
          }
        });
      }
    },
    handleClickMethod(method) {
      this.selectedMethod = method;
      if (method == "model") {
        this.arrItemSN = [
          {
            id: 0,
            serialNumber: "",
            stockCode:"",
            bomId: "",
            error: "",
          },
        ];
      } else {
        this.selectedOldBom = null;
        this.selectedNewBom = null;
      }
    },
    handleChangeMethod(method) {
      if (method == "model") {
        this.arrItemSN = [
          {
            id: 0,
            serialNumber: "",
            stockCode:"",
            bomId: "",
            error: "",
          },
        ];
      } else {
        this.selectedOldBom = null;
        this.selectedNewBom = null;
      }
    },
    setSelectedOldNewBom(data) {
      if (this.openModalSelectBomType == "onboard") {
        this.selectedNewBom = data;
      } else if (this.openModalSelectBomType == "removable") {
        this.selectedOldBom = data;
      }
      $("#modalSelectOldNewBom").modal("hide");
      this.openModalSelectBomType = "";
    },
    addItemSerialNumber() {
      this.arrItemSN.push({
        id: this.arrItemSN[this.arrItemSN.length - 1].id + 1,
        serialNumber: "",
        bomId: "",
        error: "",
        stockCode: "",
      });
    },
    removeItemSerialNumber(id) {
      this.arrItemSN = this.arrItemSN.filter((item) => item.id !== id);
    },
    sidebar() {
      $("#wrapper").toggleClass("toggled");
    },
    openModalBom() {
      if (this.itemChoose.itemCode) {
        this.$http
          .get(process.env.GET_CATALOG_BOM + this.itemChoose.itemCode, {
            headers: {
              "Asani-Token": localStorage.getItem("jwt"),
            },
          })
          .then((res) => {
            if (res.data.status == 200) {
              this.selectBom = res.data.content;
              $("#modalSelectBom").modal("show");
            }
          })
          .catch((error) => {
            swal("Sorry", error.response.data.message, "error", {
              button: "Ok",
            }).then((v) => {
              if (error.response.data.status == 401) {
                this.handleLogout();
              }
            });
          });
      }
    },
    openModalOnboardBom(type) {
      if(this.selectedMethod == 'serial' && this.arrItemSN.length < 1) {
        swal("Error", "Masukkan minimal 2 SN dengan BOM yang sama", "error");
        return;
      }
      this.selectBom = [];
      if (this.itemChoose.itemCode) {
        this.$http
          .post(
            process.env.ASSEMBLY_GET_ONBOARD_BOM_ITEM,
            {
              itemCode: Number(this.itemChoose.itemCode),
              bomType: type,
            },
            {
              headers: {
                "Asani-Token": localStorage.getItem("jwt"),
              },
            }
          )
          .then((res) => {
            if (res.data.status == 200) {
              this.selectBom = res.data.data;
              this.openModalSelectBomType = type;
              $("#modalSelectOldNewBom").modal("show");
            }
          })
          .catch((error) => {
            swal("Sorry", error.response.data.message, "error", {
              button: "Ok",
            }).then((v) => {
              if (error.response.data.status == 401) {
                this.handleLogout();
              }
            });
          });
      }
    },
    toPage(e) {
      this.$router.push(e);
    },
    setBom(item) {
      this.bom = item;
      $("#modalSelectBom").modal("hide");
    },
    getWarehouse() {
      this.$http
        .get(process.env.GET_WAREHOUSE_BY_STATUS + this.getWarehouseStatus, {
          headers: {
            "Asani-Token": localStorage.getItem("jwt"),
          },
        })
        .then((res) => {
          this.selectWarehouse = res.data.content;
        })
        .catch((error) => {
          swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          }).then((v) => {
            if (error.response.data.status == 401) {
              this.handleLogout();
            }
          });
        });
    },
    doSearchSnRemove() {
      this.$http
        .post(
          process.env.ASSEMBLY_SEARCH_SN_REMOVE,
          {
            scsn: this.snsc.replace(this.spaceRegex, " "),
          },
          {
            headers: {
              "Asani-Token": localStorage.getItem("jwt"),
            },
          }
        )
        .then((res) => {
          if (res.data.status == 200) {
            let datas = res.data.content;
            this.warehouseAwal = datas.warehouse;
            let boms = [];
            datas.bomItem.forEach((el) => {
              boms.push(el);
            });
            console.log("boms", boms);
            this.selectLepasPart = boms;
            this.snLepas = res.data.content;
            this.removeSelected = [];
          } else {
            swal("Error", res.data.message, "error");
            this.snLepas = "";
            this.warehouseAwal = "";
            this.removeSelected = [];
          }
        })
        .catch((error) => {
          swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          }).then((v) => {
            if (error.response.data.status == 401) {
              this.handleLogout();
            }
          });
        });
    },
    doSearchSn() {
      this.$http
        .post(
          process.env.ASSEMBLY_SEARCH_SN_UPDOWN,
          {
            scsn: this.snsc.replace(this.spaceRegex, " "),
            itemCode: this.itemChoose.itemCode,
            warehouse: this.warehouse,
            bomItem: this.bom.itemBom,
            isWrong: this.selectedCase.case,
          },
          {
            headers: {
              "Asani-Token": localStorage.getItem("jwt"),
            },
          }
        )
        .then((res) => {
          if (res.data.status == 200) {
            var found = false;
            if (this.snSelected.length == 0) {
              this.notifTitle =
                res.data.content.itemGroup + " - " + res.data.content.itemName;
              this.snItemName = res.data.content.itemName;
              this.snSelected.push(res.data.content);
              // $("#modalSnAssembly").modal("show")
            } else {
              this.snSelected.forEach((el) => {
                if (el.serialNumber == res.data.content.serialNumber) {
                  found = true;
                } else {
                  found = false;
                }
              });
              if (found == true) {
                swal("Error", "SN sudah dipilih.", "error");
              } else if (found == false) {
                this.snSelected.push(res.data.content);
                this.notifTitle =
                  res.data.content.itemGroup +
                  " - " +
                  res.data.content.itemName;
                this.snItemName = res.data.content.itemName;
                // $("#modalSnAssembly").modal("show")
              }
            }
          } else {
            swal("Error", res.data.message, "error");
          }
        })
        .catch((error) => {
          swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          }).then((v) => {
            if (error.response.data.status == 401) {
              this.handleLogout();
            }
          });
        });
    },
    submitData() {
      if (this.perakitan == "Upgrade / Downgrade (Full Part)") {
        this.loadingBtnSave = true;
        if (
          !this.warehouse ||
          !this.itemChoose.itemCode ||
          !this.bom.bomName ||
          !this.bom.itemBom ||
          !this.snSelected.length ||
          !this.selectedCase
        ) {
          swal("Error", "Mohon lengkapi data", "error");
          this.loadingBtnSave = false;
        } else {
          this.$http
            .post(
              process.env.ASSEMBLY_SAVE_UPDOWN,
              {
                warehouse: this.warehouse,
                itemCode: this.itemChoose.itemCode,
                isWrong: this.selectedCase.case,
                bomChoosedName: this.bom.bomName,
                bomChoosedDetail: this.bom.itemBom,
                snChoosed: this.snSelected,
              },
              {
                headers: {
                  "Asani-Token": localStorage.getItem("jwt"),
                },
              }
            )
            .then((res) => {
              this.loadingBtnSave = false;
              if (res.data.status == 200) {
                swal("Success", "Berhasil Simpan", "success");
                // this.warehouse = ''
                this.itemChoose = "";
                this.bom = "";
                this.snSelected = [];
                this.snsc = "";
              } else {
                swal("Error", res.data.message, "error");
              }
              if (res.status == 417) {
                swal("Error", res.message, "error");
              }
            })
            .catch((error) => {
              this.loadingBtnSave = false;
              swal("Sorry", error.response.data.message, "error", {
                button: "Ok",
              }).then((v) => {
                if (error.response.data.status == 401) {
                  this.handleLogout();
                }
              });
            });
        }
      } else {
        if (!this.snLepas || this.removeSelected.length == 0) {
          swal("Error", "Mohon lengkapi data", "error");
        } else {
          // this.warehouse = ''
          $("#modalWarehouse").modal("show");
        }
      }
    },
    confirmRemovePart() {
      this.loadingBtnSave = true;
      let removed = [];
      for (let i in this.removeSelected) {
        removed.push(this.removeSelected[i].split("-")[0]);
      }
      this.$http
        .post(
          process.env.ASSEMBLY_SAVE_REMOVE,
          {
            data: {
              serialNumber: this.snLepas.serialNumber.replace(
                this.spaceRegex,
                " "
              ),
              stockCode: this.snLepas.stockCode.replace(this.spaceRegex, " "),
              itemCode: this.snLepas.itemCode.replace(this.spaceRegex, " "),
              itemGroup: this.snLepas.itemGroup,
              itemName: this.snLepas.itemName.replace(this.spaceRegex, " "),
              description: this.snLepas.description.replace(
                this.spaceRegex,
                " "
              ),
              warehouse: this.warehouseAwal,
              bom: this.snLepas.bom,
              bomItem: this.snLepas.bomItem,
              id: this.snLepas.id,
            },
            warehouseDestination: this.warehouse,
            partRemove: removed,
          },
          {
            headers: {
              "Asani-Token": localStorage.getItem("jwt"),
            },
          }
        )
        .then((res) => {
          this.loadingBtnSave = false;
          if (res.data.status == 200) {
            swal("Success", "Berhasil Simpan", "success");
            this.snLepas = "";
            this.snsc = "";
            this.selectLepasPart = [];
            this.removeSelected = [];
            $("#modalWarehouse").modal("hide");
          } else {
            swal("Error", res.data.message, "error");
            $("#modalWarehouse").modal("hide");
          }
        })
        .catch((error) => {
          swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          }).then((v) => {
            if (error.response.data.status == 401) {
              this.handleLogout();
            }
          });
        });
    },
    getSparepart() {
      this.selectItem = [];
      this.itemChoose = "";
      this.$http
        .get(process.env.ASSEMBLY_GET_PART + this.type, {
          headers: {
            "Asani-Token": localStorage.getItem("jwt"),
          },
        })
        .then((res) => {
          if (res.data.status == 200) {
            this.selectItem = res.data.content;
          }
        })
        .catch((error) => {
          swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          }).then((v) => {
            if (error.response.data.status == 401) {
              this.handleLogout();
            }
          });
        });
    },
    getOnboardItem(itemGroupValue) {
      this.selectItem = [];
      this.itemChoose = "";
      this.selectedOnboardItem = null;
      const itemGroup = itemGroupValue.toLowerCase();
      this.$http
        .get(process.env.ASSEMBLY_GET_ONBOARD_ITEM_LIST + `/${itemGroup}`, {
          headers: {
            "Asani-Token": localStorage.getItem("jwt"),
          },
        })
        .then((res) => {
          if (res.data.status == 200) {
            this.selectItem = res.data.content;
          }
        })
        .catch((error) => {
          swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          }).then((v) => {
            if (error.response.data.status == 401) {
              this.handleLogout();
            }
          });
        });
    },
    async updateInfoBom() {
      this.loadingBtnSave = true;
      const listSerialNumber = this.selectedMethod == "model"? []
                                  : this.arrItemSN.filter(el => el.bomId)
                                    .map((item) => item.serialNumber
                                    .replace(this.spaceRegex, " "))
      const updateBy = this.selectedMethod == "model" ? "Unit" : "SN";
      try {
        const response = await this.$http.post(
          process.env.ASSEMBLY_SAVE_ONBOARD_BOM,
          {
            updateBy,
            oldBom: this.selectedOldBom,
            NewBom: this.selectedNewBom,
            listSerialNumber,
          },
          {
            headers: {
              "Asani-Token": localStorage.getItem("jwt"),
            },
          }
        );
        this.loadingBtnSave = false;
        if (response.data.status == 200) {
          await alert().fire({
            title: "Success",
            text: "Berhasil Update Info BOM",
            icon: "success",
            confirmButtonText: "Okay",
          });
          location.reload();
        } else {
          await alert().fire({
            title: "Error",
            text: response.data.message,
            icon: "error",
            confirmButtonText: "Okay",
          });
        }
      } catch (error) {
        this.loadingBtnSave = false;
        await alert().fire({
          title: "Error",
          text: error.response.data.message,
          icon: "error",
          confirmButtonText: "Okay",
        });
        if (error.response.data.status == 401) {
          this.handleLogout();
        }
      }
    },
    getBom() {
      this.$http
        .get(process.env.GET_CATALOG_BOM + this.snSelected[0].itemCode, {
          headers: {
            "Asani-Token": localStorage.getItem("jwt"),
          },
        })
        .then((res) => {
          console.log(res);
          if (res.data.status == 200) {
            this.selectBom = res.data.content;
            $("#modalSelectBom").modal("show");
          }
        })
        .catch((error) => {
          swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          }).then((v) => {
            if (error.response.data.status == 401) {
              this.handleLogout();
            }
          });
        });
    },
    deleteSelectedSn(item) {
      let newSelected = [];
      this.snSelected.forEach((el) => {
        if (el !== item) {
          newSelected.push(el);
        }
      });
      this.snSelected = newSelected;
      if (this.snSelected.length == 0) {
        this.resetData();
      }
    },
    resetData() {
      this.bom = "";
      this.snSelected = [];
      this.selectBom = [];
      this.snsc = "";
      connsole.log("bom", this.bom);
    },
    async handleLogout() {
      try {
        const response = await this.$http.post(
          process.env.LOGOUT,
          {},
          {
            headers: {
              "Asani-Token": localStorage.getItem("jwt"),
            },
          }
        );
        if (response.data.status !== 200) {
          swal("Sorry", response.data.message, "error", {
            button: "Ok",
          });
          return;
        }
      } catch (error) {
        if (error.response.data.status != 401) {
          swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          });
          return;
        }
      }
      localStorage.removeItem("jwt");
      localStorage.removeItem("admin_name");
      localStorage.removeItem("roles");
      localStorage.removeItem("user_email");
      localStorage.removeItem("admin_id");
      localStorage.removeItem("changeCatalogPermission");
      this.$router.push("/");
    },
    cekLogin() {
      if (localStorage.getItem("jwt") == null) {
        this.$router.push("/");
      }
    },
    cekPermission() {
      this.permission = localStorage
        .getItem("roles")
        .replace(/"/g, "")
        .replace("[", "")
        .replace("]", "")
        .split(",");
      for (var i = 0; i < this.permission.length; i++) {
        if (this.permission[i] == "10") {
          this.viewEmployee = true;
        }

        if (this.permission[i] == "23.1") {
          this.allowSetWrong = true;
        }
        if( this.permission[i] == "24.4") {
          this.permissionChangeInfoBomByModel = true;
        }
        if(this.permission[i] == "24.6") {
          this.permissionChangeInfoBomBySn = true;
        }
      }
      if (this.viewEmployee == false) {
        this.$router.push("/");
      }
    },
  },
  watch: {
    perakitan: {
      handler: function () {
        this.warehouse = "Roxy Warehouse - ASN";
        this.snsc = "";
        this.snSelected = [];
        this.itemChoose = "";
        this.bom = [];
        this.type = "";
        this.snLepas = [];
        this.selectLepasPart = [];
        this.removeSelected = [];
      },
    },
    type: {
      handler: function (val) {
        this.itemChoose = "";
        if (val) {
          if (this.perakitan == "Update Info BOM") {
            this.getOnboardItem(val);
          } else {
            this.getSparepart();
          }
        }
        this.bom = "";
        this.selectBom = "";
        this.snSelected = [];
      },
    },
    itemChoose: {
      handler: function () {
        this.bom = "";
        this.selectBom = "";
        this.snSelected = [];
        this.selectedOldBom = null;
        this.selectedNewBom = null;
        this.arrItemSN = [
          {
            id: 0,
            serialNumber: "",
            stockCode:"",
            bomId: "",
            error: "",
          },
        ];
      },
    },
    selectedCase: {
      handler: function () {
        if (this.selectedCase.case == 0) {
          this.getWarehouseStatus = "/Ready Stock & Repair";
        } else {
          this.getWarehouseStatus = "/all";
        }

        this.getWarehouse();
      },
    },
  },
  created() {
    this.admin = localStorage.getItem("admin_name");
    this.adminId = localStorage.getItem("admin_id");
    this.enableSNWrongAllWarehouse = localStorage.getItem(
      "enableSNWrongAllWarehouse"
    );
    this.cekLogin();
    this.cekPermission();
    this.getWarehouse();
  },
};
</script>

<style scoped>
.toggle-container {
  display: flex;
  gap: 20px;
}

.selected-toggle-card {
  flex: 1;
  background: #ffffff;
  border: 1px solid #CFD3D9;
  border-radius: 12px;
  padding: 1.5rem;
  text-align: center;
  transition: all 0.3s ease;
  min-height: 250px;
}

.toggle-card {
  flex: 1;
  background: #f8f9fa;
  border: 1px dashed #CFD3D9;
  border-radius: 12px;
  padding: 0;
  text-align: center;
  transition: all 0.3s ease;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 250px;
}

.toggle-btn .btn-old-bom {
  min-width: 160px;
  border-radius: 6px;
  padding: 10px 28px;
  font-weight: 500;
  font-size: 15px;
  transition: all 0.3s ease;
  border: none;
}

.btn-old-bom {
  background-color: white;
  color: #333;
  border: 2px solid #d0d0d0;
}

.btn-new-bom {
  background-color: #007bff;
  color: white;
  border: 2px solid #007bff;
}

.component-border {
  border: 1px solid rgb(206, 212, 218);
  background-color: rgb(233, 236, 239);
}

.bom-selection {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/Assembly/ChangeSpecPage.vue